// extracted by mini-css-extract-plugin
export default {"walletContainer":"wallet-component_walletContainer__Bi+dD","or":"wallet-component_or__zsOFv"};